<template>
    <div class="sbs-pagination">
        <SbsButton
            v-if="withMoreButton"
            class="sbs-pagination__more-btn mb-3"
            v-bind="showMoreButtonData"
            @click="showMore">
            Показать еще
        </SbsButton>
        <div
            v-if="count"
            class="sbs-pagination__container">
            <SbsButton
                v-bind="navigationButtonData"
                :disabled="isPrevButtonDisabled"
                @click="prevPage">
                Назад
                <template #prepend>
                    <SbsIcon
                        class="mr-2 px-0"
                        iconName="chevron-left" />
                </template>
            </SbsButton>
            <div class="sbs-pagination__items">
                <SbsPaginationItem
                    v-for="(idx, i) in totalPagesArray"
                    :key="i"
                    :isActive="isCurrentPage(idx)"
                    :isShowDots="isShowDots(idx)"
                    @changePage="changePage(idx)">
                    {{ idx }}
                </SbsPaginationItem>
            </div>
            <SbsButton
                v-bind="navigationButtonData"
                :disabled="isNextButtonDisabled"
                @click="nextPage">
                Дальше
                <template #append>
                    <SbsIcon
                        class="ml-2 px-0"
                        iconName="chevron-right" />
                </template>
            </SbsButton>
        </div>
    </div>
</template>

<script>
import SbsPaginationItem from './SbsPaginationItem.vue';
import { MAX_PAGINATION_ITEMS_LENGTH } from './maxPaginationItemsLength.js';

const DOTS = '...';

export default {
    name: 'SbsPagination',
    emits: ['update:modelValue', 'showMore'],
    components: {
        SbsPaginationItem,
    },
    computed: {
        currentPage: {
            get() {
                return this.modelValue;
            },
            set(value) {
                this.$emit('update:modelValue', value);
            },
        },
        totalPagesArray() {
            return this.pagination(this.currentPage, this.count, this.maxPaginationItemsLength);
        },
        showMoreButtonData() {
            return {
                borderTheme: 'primary',
                fullWidth: true,
                static: true,
                size: 'large',
            };
        },
        navigationButtonData() {
            return {
                colorTheme: 'primary',
                bordered: false,
                static: true,
            };
        },
        isPrevButtonDisabled() {
            return this.currentPage === 1;
        },
        isNextButtonDisabled() {
            return this.currentPage === this.count;
        },
    },
    methods: {
        generateArray(length, start = 0) {
            return Array.from(Array(length), (_, i) => i + start + 1);
        },
        pagination(currentPage = 1, totalPages, maxItems) {

            if (totalPages <= maxItems) {
                return this.generateArray(totalPages);
            } else if (currentPage < maxItems - 1) {
                return [...this.generateArray(maxItems - 1), DOTS, totalPages];
            } else if (currentPage > totalPages - maxItems + 2) {
                return [
                    1,
                    DOTS,
                    ...this.generateArray(maxItems - 1, totalPages - maxItems + 1),
                ];
            }

            return [
                1,
                DOTS,
                ...this.generateArray(maxItems - 2, currentPage - Math.floor(maxItems / 2)),
                DOTS,
                totalPages,
            ];
        },
        isCurrentPage(idx) {
            return this.currentPage === idx;
        },
        isShowDots(idx) {
            return idx === DOTS;
        },
        changePage(pageNumber) {
            if (pageNumber === DOTS) return;

            this.currentPage = pageNumber;
        },
        prevPage() {
            if (this.isPrevButtonDisabled) return;

            this.currentPage--;
        },
        nextPage() {
            if (this.isNextButtonDisabled) return;

            this.currentPage++;
        },
        showMore() {
            this.$emit('showMore');
        },
    },
    props: {
        /**
         * Номер текущей страницы
         * @model
         */
        modelValue: {
            type: Number,
            default: 1,
        },
        /**
        * Количество всех страниц
        */
        count: {
            type: Number,
            default: null,
            required: true,
        },
        /**
        * Отображение кнопки "Показать еще"
        */
        withMoreButton: {
            type: Boolean,
            default: false,
        },
        /**
        * Максимальное количество элементов в списке пагинации
        */
        maxPaginationItemsLength: {
            type: Number,
            default: MAX_PAGINATION_ITEMS_LENGTH,
        },
    },
};
</script>

<style lang="scss">
.sbs-pagination {
    width: 100%;

    &__container {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .sbs-button {
            padding: 7px 0;
        }
    }

    &__items {
        display: flex;
        gap: 2px;
        align-items: center;
        justify-content: center;
    }
}
</style>
